import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { CoreLogService } from "../../services/log.service";
import { CoreCOMService } from "../../services/com.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { PhoneCallError, SnackBarMessageType, LocationServiceStatus } from "../../shared/contentTypes";
import { DeviceLocationService } from "../../services/deviceLocation.service";

@Component({
  selector: "ya-customAction",
  templateUrl: "./customAction.component.html",
  styleUrls: ["./customAction.component.scss"]
})
export class CustomActionComponent implements OnInit {
  @Input() className: string = "";
  @Input() actionData: any = {};
  constructor(private _router: Router
    , private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _coreComService: CoreCOMService
    , private _snackBarService: SnackBarService
    , private _deviceLocationService: DeviceLocationService) { }

  ngOnInit() {
    const me = this;
  }

  /**
 * Calls when each news favorite icon, clicked by user
 * @param news The newsviewmodel that it's favorite icon has been clicked
 */
  public onPhoneCallAction(actionData: any) {
    const me = this;
    me._coreComService.environment.phoneCall.dial(
      actionData.phone_no,
      function (error) {
        if (error === PhoneCallError.empty) {
          me._coreLogService.error("LocationMap.onPhoneCallAction", "Cordova dial Error callbackfuntion - Unknown phone number", error);
        } else {
          me._coreLogService.error("LocationMap.onPhoneCallAction", "Cordova dial Error callbackfuntion - Dialer Error", error);
        }
      },
      function (success) {
        me._coreLogService.info("LocationMap.onPhoneCallAction", "Cordova dial Success callbackfuntion");
      }
    );
  }

  public async onDirectionRequest(actionData: any): Promise<void> {
    const me = this;
    const locationServiceStatus = await me._deviceLocationService.getLocationServiceStatus();
    if (locationServiceStatus === LocationServiceStatus.IsNotActivated) {
      window.open(`http://maps.google.com/maps?&daddr=${actionData.latitude},${actionData.longitude}`, "_system");
      return;
    }
    if (locationServiceStatus === LocationServiceStatus.ResponseError) {
      return;
    }
    const coordinates = await me._deviceLocationService.getCurrentPosition();
    if (coordinates) {
      window.open(`http://maps.google.com/maps?saddr=${coordinates.latitude},${coordinates.longitude}&daddr=${actionData.latitude},${actionData.longitude}`, "_system");
    } else {
      me._snackBarService.ShowMessage(snackBarMessageKey.unkownLocation, SnackBarMessageType.Error);
    }
  }

  public openEMailApp(actionData: any): void {
    window.open("mailto:" + actionData.mail, "_system");
    // location.href = "mailto:" + actionData.mail;
  }

  public routeToPath(path: string) {
    this._router.navigate(["/" + path]);
  }
}
